/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PhysioCategory from './physio-category';
import PhysioCategoryDetail from './physio-category-detail';
import PhysioCategoryUpdate from './physio-category-update';
import PhysioCategoryDeleteDialog from './physio-category-delete-dialog';

const PhysioCategoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PhysioCategory />} />
    <Route path="new" element={<PhysioCategoryUpdate />} />
    <Route path=":id">
      <Route index element={<PhysioCategoryDetail />} />
      <Route path="edit" element={<PhysioCategoryUpdate />} />
      <Route path="delete" element={<PhysioCategoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PhysioCategoryRoutes;
